import Image from "@feature/Image"
import Link from "@feature/Link"
import { Box, BoxTypeMap, Typography } from "@mui/material"
import { OverridableComponent, OverrideProps } from "@mui/material/OverridableComponent"
import { useAppDispatch } from 'app/hooks'
import { termNavClicked } from 'app/thunks'
import { Term } from "types"

type TermCardCustomProps = {
  term: Term
}
type TermCardTypeMap<P = {}, D extends React.ElementType = 'div'> = BoxTypeMap<
  TermCardCustomProps & P,
  D
>

type TermCardProps<
  D extends React.ElementType = BoxTypeMap['defaultComponent'],
  P = {}
> = OverrideProps<TermCardTypeMap<P, D>, D>

const TermCard: OverridableComponent<TermCardTypeMap> = ({ term: { taxonomyId, uri, name, image, id }, ...boxProps }: TermCardProps) => {
  // const uri = useSelector(getSelecturi(taxonomyId, slug) )
  const dispatch = useAppDispatch()

  if (!uri) return <></>

  const handleClick = () => {
    dispatch(termNavClicked({ taxonomyId, termId: id, reset: true }))
  }

  return (
    <Box {...boxProps} textAlign="center">
      <Link to={uri} color="inherit" onClick={handleClick}>
        <Image
          imageData={image}
          size={'MEDIUM'}
          fillPercentage={60}
          imgProps={{ sx: { top: '40%' } }}
          withBorder
          mb={0.6}
          childWrapperProps={{ padding: 2, justifyContent: 'flex-start', alignItems: 'center' }}
        >
          <Typography variant="h5" mt={'75%'} textTransform="uppercase">
            {name}
          </Typography>
        </Image>
      </Link>
    </Box>
  )
}

export default TermCard